import React, { useState } from 'react';
import { ui } from './toolTheme';
const API_BASE = process.env.REACT_APP_API_BASE || '';

const BgUpscalePage = ({ setPage }) => {
  const [file, setFile] = useState(null);
  const [action, setAction] = useState('remove-bg');
  const [scale, setScale] = useState(2);
  const [err, setErr] = useState('');

  const run = async () => {
    if (!file) return;
    setErr('');
    try {
      const fd = new FormData(); fd.append('file', file); fd.append('action', action); fd.append('scale', String(scale));
      const res = await fetch(`${API_BASE}/api/image/bg-upscale`, { method: 'POST', body: fd });
      if (!res.ok) throw new Error((await res.json().catch(() => ({}))).message || 'Failed');
      const blob = await res.blob();
      const url = URL.createObjectURL(blob); const a = document.createElement('a');
      a.href = url; a.download = `${file.name.replace(/\.[^.]+$/, '')}_${action}.png`; a.click(); URL.revokeObjectURL(url);
    } catch (e) { setErr(e.message || 'Failed'); }
  };

  return <main style={ui.page}><div style={{...ui.container, maxWidth:760}}>
    <button onClick={()=>setPage('/tools')} style={ui.backBtn}>← Back to Tools</button>
    <div style={ui.card}><h1 style={ui.sectionTitle}>Background Remover + Upscaler</h1></div>
    <div style={{...ui.card, marginTop:14}}>
      <label style={ui.label}>Image File</label>
      <input type='file' accept='image/*' onChange={(e)=>setFile(e.target.files?.[0]||null)} style={ui.fileInput} />
      <div style={{display:'grid', gridTemplateColumns:'1fr 120px auto', gap:8, marginTop:10, alignItems:'center'}}>
      <select value={action} onChange={(e)=>setAction(e.target.value)} style={ui.select}>
        <option value='remove-bg'>Remove Background</option>
        <option value='upscale'>Upscale</option>
      </select>
      <input type='number' min={1} max={4} value={scale} onChange={(e)=>setScale(Number(e.target.value)||2)} style={ui.input} />
      <button onClick={run} style={ui.primaryBtn}>Run</button>
      </div>
      {err && <div style={ui.error}>{err}</div>}
    </div>
  </div></main>;
};

export default BgUpscalePage;
